/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2026-01-09 16:41:35
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2026-01-09 16:50:04
 */
import { useState, useCallback, useEffect } from 'react'
import { message } from 'antd'
import {
  sliceCharactersLen,
  raplaceEmoji,
  filterIllegalCharacters,
  calcCharactersLength
} from '../../../../utils/utils'
import { DEFAULT_NAMING_RULE } from '../constants'

export const useNamingLogic = (initialRule: string[] = DEFAULT_NAMING_RULE) => {
  const [namingRule, setNamingRule] = useState<string[]>(initialRule)

  // 支持动态更新初始值
  useEffect(() => {
    if (initialRule && initialRule !== DEFAULT_NAMING_RULE) {
      setNamingRule(initialRule)
    }
  }, [initialRule])

  const onChangeSelectNameData = useCallback(
    (value: string[], list?: any[]) => {
      if (value.length > 5) {
        value = value.slice(0, 5)
        if (list) list = list.slice(0, 5)
        message.warning('最多支持选择5个命名条件!')
      }

      const processedValue = value.reduce((prev: string[], cur: string) => {
        let initLength = cur.length
        cur = raplaceEmoji(cur)
        cur = filterIllegalCharacters(cur)
        if (initLength !== cur.length) {
          message.warning('特殊字符已过滤！')
        }

        if (cur.trim() !== '') {
          if (!cur.includes('title') && calcCharactersLength(cur) > 32) {
            cur = sliceCharactersLen(cur, 32)
            message.warning('最多支持16个汉字或32个字符！')
          }
          if (!prev.includes(cur)) {
            prev.push(cur)
          }
        } else {
          if (list) list.splice(prev.length, 1)
        }
        return prev
      }, [])

      setNamingRule(processedValue)
    },
    []
  )

  return {
    namingRule,
    setNamingRule,
    onChangeSelectNameData
  }
}
